import { Button, Container, FormControl, Input, Box, CircularProgress } from "@mui/material"
import { useEffect, useState } from "react"
import { GeneralStyles } from "../../styles/GeneralStyles"
import { FileUploadFormStyles } from "./FileUploadFormStyles"
import { downloadModelListReport, downloadProvidenceReport, uploadModelListFile, uploadProvidenceFile, uploadGenericModelListFile, downloadGenericTemplate } from "../../services/CatalogsService"
import {notifyReportDownloadSucess, notifyUploadFileSucess} from "../notifications"
import { useLocation } from "react-router-dom"
import { ModalEntityWithErrors } from "../ModalEntityWithErrors"

const FileUploadForm = ({handleCloseModal}) => {
    const [selectedFile, setSelectedFile] = useState('')
    const [isLoadingUploadFile, setIsLoadingUploadFile] = useState(false)
    const token = localStorage.getItem("site")
    const [typeEntity, setTypeEntity] = useState("")
    const location = useLocation();
    const [entityWithErrors, setEntityWithErrors] = useState([])
    const {  pathname } = location;
    const [inputFileKey, setInputFileKey] = useState(Date.now())
    

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        if (selectedFile && file && file.lastModified === selectedFile.lastModified) {
            setInputFileKey(Date.now())
        } else {
            setSelectedFile(file)
        }
    }

    const downloadModelListReportAction = async () => {
        try {
            const response = await downloadModelListReport(token)
            if (response.status === 200) {
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${typeEntity}.csv`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                notifyReportDownloadSucess("Template Model List was download successfully")
            }
        } catch (err) {
        }
    }
    
    const downloadProvidenceReportAction = async () => {
        try {
            const response = await downloadProvidenceReport(token)
            if (response.status === 200) {
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${typeEntity}.csv`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                notifyReportDownloadSucess("Template Providence was download successfully")
            }
        } catch (err) {
        }
    }

    const downloadGenericModelListReportAction = async () => {
        try {
            const response = await downloadGenericTemplate(token)
            if (response.status === 200) {
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${typeEntity}.csv`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                notifyReportDownloadSucess("Template Providence was download successfully")
            }
        } catch (err) {
        }
    }

    const uploadProvidenceFileAction = async () => {
        setEntityWithErrors([])
        setIsLoadingUploadFile(true)
        const formData = new FormData()
        formData.append('file', selectedFile)
        try {
            const response = await uploadProvidenceFile(token, formData)
            if (response.data.content.length > 0) {
                notifyUploadFileSucess(response.data.message)
                setIsLoadingUploadFile(false)
            }
            if (response.data.contentError.length > 0){
                setEntityWithErrors(response.data.contentError)
                setIsLoadingUploadFile(false)
            }
        } catch (err) {
            setIsLoadingUploadFile(false)
        } finally {
            setSelectedFile(null)
            setInputFileKey(Date.now())
        }
    }


    const uploadModelListFileAction = async () => {
        setEntityWithErrors([])
        setIsLoadingUploadFile(true)
        const formData = new FormData()
        formData.append('file', selectedFile)
        let response = null;
        try {
            switch (pathname) {
                case "/dashboard/products/CatGeneric":
                    response = await uploadGenericModelListFile(token, formData)
                    break;
                /*case "/dashboard/products/CotscoProd":
                    response = await uploadGenericModelListFile(token, formData)
                    break;
                case "/dashboard/products/GenericProd":
                    response = await uploadGenericModelListFile(token, formData)
                    break;*/
                default:
                    response = await uploadModelListFile(token, formData)
            }            
            if (response.data.content.length > 0) {
                notifyUploadFileSucess(response.data.message)
                setIsLoadingUploadFile(false)
            }
            if (response.data.contentError.length > 0){
                setEntityWithErrors(response.data.contentError)
                setIsLoadingUploadFile(false)
            }
        } catch (err) {
            setIsLoadingUploadFile(false)
        } finally {
            setSelectedFile(null)
            setInputFileKey(Date.now())
        }
    }

    const downloadTemplate = (type) => {
        switch (type) {
            case "templateModel":
                downloadModelListReportAction(typeEntity)
                break
            case "templateProvince":
                downloadProvidenceReportAction(typeEntity)
                break
            case "templateGenericModelList":
                downloadGenericModelListReportAction(typeEntity)
                break
            default:
                break
        }
    }

    const handleUploadFile = (e, type) => {
        e.preventDefault()
        switch (type) {
            case "templateModel":
                uploadModelListFileAction()
                break;
            case "templateProvince":
                uploadProvidenceFileAction()
                break;
            case "templateGenericModelList":
                uploadModelListFileAction()
                break;    
            default:
                break;
        }
    }

    useEffect(() => {
        if (pathname === "/dashboard/products") {
            setTypeEntity("templateModel")
        } else if (pathname === "/dashboard/provinces"){
            setTypeEntity("templateProvince")
        } else if (pathname === "/dashboard/products/CatGeneric") {
            setTypeEntity("templateGenericModelList")
        }
    },[pathname])

    return (
        <Container maxWidth="sm">
            <FormControl fullWidth>
                <Input 
                    key={inputFileKey}
                    id="fileInput"
                    type="file"
                    onChange={handleFileChange}
                    inputProps={{accept: ".csv"}}
                />
            </FormControl>
            <Box sx={FileUploadFormStyles.btnsContainer} component="div">
                <Button variant="contained" color="primary" sx={GeneralStyles.btnGrey} 
                    onClick={()=> downloadTemplate(typeEntity)}
                >
                    Download Template
                </Button>
                <Box sx={{marginLeft:"25px"}} component="div">
                    <Button variant="contained" color="primary" sx={GeneralStyles.btnGrey} onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    <Button variant="contained"  color="primary" onClick={(e) => handleUploadFile(e, typeEntity)} disabled={!selectedFile} sx={{marginLeft:"10px"}}>
                        {isLoadingUploadFile ? <CircularProgress size={24} /> : "Upload File"}
                    </Button>
                </Box>
            </Box>
            {entityWithErrors.length > 0 && (
                <ModalEntityWithErrors 
                    entityWithErrors={entityWithErrors} 
                    typeEntity={typeEntity} 
                />
            )}
        </Container>
    )
}

export default FileUploadForm